<a class="help-trigger" href="javascript:{}" (click)="onClick()" tabindex="-1">
  <i aria-hidden="true" class="info-icon"></i>
</a>
